import "./icon.scss";
// https://fonts.google.com/icons?icon.style=Rounded

const list = {
  clipboard: "content_paste",
  // clipboard_checked: "inventry",
  forward:   "arrow_forward_ios",
  drilldown: "arrow_forward_ios",
  menu:      "menu"
};

const Icon = ({ className, style = "rounded", icon, rotate, children, after = false, ...restProps }) => {
  if (!icon) {
    return null;
  }
  const text = list[icon] ?? icon;
  const classList = [`icon material-symbols-${style}`];
  if (rotate) {
    classList.push(`rotate-${rotate}`);
  }
  if (className) {
    classList.push(className);
  }
  const iconElem = <span className={classList.join(" ")} {...restProps}>{text}</span>;
  if (!children) {
    return iconElem;
  }
  return (<span className="d-inline-flex align-items-center">
    {!after && iconElem}
    {children}
    {after && iconElem}
  </span>);
};

export default Icon;